import "./Navbar.css"
import {
    Routes, Route, Link, BrowserRouter as Router
} from "react-router-dom"
export default function Navbar() {
    return (
        <div className="navbar lg:w-3/4  w-full mx-auto mt-10">
            <Router>
                <div className="navbar-content flex md:flex-row flex-col place-items-center text-3xl md:space-x-10 text-white">
                    <div className="about">
                        <a href="#about" className="underline-hover">About</a>
                    </div>
                    <div className="myworks">
                        <a href="#projects" className="underline-hover">Projects</a>
                    </div>
                    <div className="contact">
                        <a href="#contact" className="underline-hover">Contact</a>
                    </div>
                    <div className="myblog">
                        <a href="/myblog" className="underline-hover">My blog</a>
                    </div>
                </div>
            </Router >
        </div>
           
    )
}